import { modals } from "@mantine/modals";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ErrorNotification } from "../components/notification/ErrorNotification.tsx";
import { CreateMailDto } from "../models/CreateMailDto.ts";
import { useMailService } from "../services/useMailService.ts";

export function useMailMutation() {
  const { createMail } = useMailService();
  const queryClient = useQueryClient();
  const saveMailMutation = useMutation({
    mutationFn: (mailData: CreateMailDto) => createMail(mailData),
    onSuccess: () => {
      modals.closeAll();
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ["mails"] });
      }, 300);
    },
    onError: () => {
      ErrorNotification("A problem occurred while submitting the email.");
    }
  });

  return {
    saveMailMutation
  };
}
